.tooltip[data-entering] {
    animation: var(--animation-slide-in) 500ms var(--spring-1);
}

.tooltip[data-exiting] {
    animation: var(--animation-slide-out) 500ms var(--spring-1);
}

.arrow {
    display: block;
}

.tooltip {
    background-color: var(--colorSurfacePopoverDark);
    color: var(--colorTextOnToastDark);
    border-radius: 8px;
    padding: var(--spacing-xs);
    font-family: var(--fontFamilySansMedium), sans-serif;
    font-size: 12px;
    line-height: 1.25;
    text-align: center;
    /* Establish a stacking context so BaseOverlayArrow's z-index: -1 stays contained here. */
    isolation: isolate;
}
